import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";

export const PartnerBenefitsModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold dark:text-white">
            Founding Partner Benefits
          </DialogTitle>
          <DialogDescription className="sr-only">
            List of exclusive benefits for founding partners
          </DialogDescription>
        </DialogHeader>
        <div className="mt-12 space-y-4">
          <div className="flex gap-3">
            <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 font-bold flex items-center justify-center">
              1
            </span>
            <div className="flex-1">
              <h4 className="font-semibold text-foreground mb-4">Lifetime 25% Discount</h4>
              <p className="text-sm text-muted-foreground">
                Lock in a permanent 25% discount on your subscription as long as you remain an active customer. 
                This discount applies to any plan tier you choose.
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 font-bold flex items-center justify-center">
              2
            </span>
            <div className="flex-1">
              <h4 className="font-semibold text-foreground mb-4">Priority Support & Feature Requests</h4>
              <p className="text-sm text-muted-foreground">
                Get exclusive access to our priority support channel with 2-hour response times and direct 
                influence on our product roadmap through quarterly strategy calls.
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
